import type { detonatingInterface } from '@/types/viewsType/roomType'

// 自动升级的倒计时
const AUTO_UPGRADE_TIME = 60 * 1000 * 5 + 10000
let upgradeTimer: NodeJS.Timeout | null = null

// 房间炸弹引爆
export const useDetonatingStore = defineStore({
  id: 'detonating',
  state: () => ({
    detonatingInfo: {} as detonatingInterface // 爆蛋信息
  }),
  getters: {
    /** 当前是否为引爆状态 */
    isDetonatingState: (state) => {
      return state.detonatingInfo.detonatingState >= 100
    }
  },
  actions: {
    // 设置爆蛋信息
    setDetonatingInfo(data: detonatingInterface) {
      this.detonatingInfo = data
    },
    // 监听引爆进度更新
    onDetonatingUpdate(data) {
      const roomStore = useRoomStore()
      const publicStore = usePublicStore()
      if (data.roomId === roomStore.roomId) {
        this.detonatingInfo = {
          ...this.detonatingInfo,
          ...data,
          detonatingLv: data.lv
        }
        // 需要手动更新爆弹总值
        this.updateDetonatingTotal()
        // 通知iOS更新爆蛋值
        if (publicStore.isIOSWebView) {
          window['appFun']('updateTreasureBallValue', {
            detonatingLv: this.detonatingInfo.detonatingLv,
            detonating: this.detonatingInfo.detonating,
            detonatingState: this.detonatingInfo.detonatingState,
            totalDetonating: this.detonatingInfo.totalDetonating,
            detonatingAccelerate: this.detonatingInfo.detonatingAccelerate
          })
        }
      }
    },
    /**
     * 手动更新爆蛋总值(注：需要在lv更新之后再调用，更新依赖于lv)
     */
    updateDetonatingTotal() {
      const publicStore = usePublicStore()
      this.detonatingInfo.totalDetonating =
        publicStore.clientConfigure.detonatingTotal?.[
          Math.max(this.detonatingInfo.detonatingLv - 1, 0)
        ]
    },
    /**
     * 延迟5分钟10秒后，本地自动加一级（长时间没有抢的情况下）
     */
    detonatingBombLocalUpgrade() {
      const publicStore = usePublicStore()
      // 延迟5分钟10秒后，本地自动加一级
      this.stopLocalUpgradeCountDown()
      console.log('开始自动升级倒计时')

      upgradeTimer = setTimeout(() => {
        if (this.isDetonatingState) {
          const level =
            this.detonatingInfo.detonatingLv >= 7
              ? 0
              : this.detonatingInfo.detonatingLv + 1
          this.detonatingInfo.detonatingLv = level
          this.detonatingInfo.detonatingState = 0
          this.detonatingInfo.detonating = 0
          // 需要手动更新爆弹总值
          this.updateDetonatingTotal()

          // 通知iOS更新爆蛋值
          if (publicStore.isIOSWebView) {
            window['appFun']('updateTreasureBallValue', {
              detonatingLv: this.detonatingInfo.detonatingLv,
              detonating: this.detonatingInfo.detonating,
              detonatingState: this.detonatingInfo.detonatingState,
              totalDetonating: this.detonatingInfo.totalDetonating,
              detonatingAccelerate: this.detonatingInfo.detonatingAccelerate
            })
          }
        }
      }, AUTO_UPGRADE_TIME)
    },
    /**
     * 停止倒计时
     */
    stopLocalUpgradeCountDown() {
      if (upgradeTimer) {
        console.log('调试 => 清除自动升级倒计时')
        clearTimeout(upgradeTimer)
        upgradeTimer = null
      }
    }
  }
  // persist: {
  //   key: 'detonatingStore',
  //   paths: []
  // }
})
